module.exports = __webpack_public_path__ + "assets/img/医疗机构执业许可证1.2ba20060.png";